export default "__VITE_ASSET__06a6ac9c__"